export default __webpack_public_path__ + "static/media/ev-accommodation.c4b9c9a4.svg";